import { render, staticRenderFns } from "./down-bank-edit.vue?vue&type=template&id=2652551f&scoped=true&"
import script from "./down-bank-edit.vue?vue&type=script&lang=js&"
export * from "./down-bank-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652551f",
  null
  
)

export default component.exports